import { FormControl, FormLabel } from '@chakra-ui/form-control'
import { Input, InputGroup } from '@chakra-ui/input'
import { Box, Icon } from '@chakra-ui/react'
import React, { forwardRef } from 'react'
import { BiCalendar } from 'react-icons/bi'

const DateInput = forwardRef(({ label, control, ...props }, ref) => {
  return (
    <FormControl minWidth="6em">
      <FormLabel color="gray.500" fontSize="sm">{label}</FormLabel>
      <InputGroup position="relative">
        <Input type="date" {...props} ref={ref} />
        <Box
          zIndex="docked"
          position="absolute"
          right="2"
          top="1px"
          bottom="1px"
          pointerEvents="none"
          py="2"
          px="2"
          bg="white"
        >
          <Icon w="5" h="5" as={BiCalendar} />
        </Box>
      </InputGroup>
    </FormControl>
  )
})

DateInput.displayName = 'DateInput'

export default DateInput
